// Polyfill for CustomEvent where not implemented:
const getCustomEvent = () => window.CustomEvent || function CustomEvent(
  name,
  opts
) {
  const params = opts || { bubbles: false, cancelable: false, detail: null };
  const evt = document.createEvent('CustomEvent');
  evt.initCustomEvent(name, params.bubbles, params.cancelable, params.detail);
  return evt;
};

export default getCustomEvent;
